<div class="starter-guide">
  <header class="starter-guide__header">
    <h2 class="starter-guide__title">{{ title }}</h2>
    <p class="starter-guide__subtitle">{{ subtitle() }}</p>
  </header>

  @if (content().intro; as intro) {
    <div class="starter-guide__intro">
      @if (introHeading(); as heading) {
        <h3 class="starter-guide__intro-heading">{{ heading }}</h3>
      }
      @for (paragraph of intro.paragraphs; track $index) {
        <p class="starter-guide__intro-text">{{ paragraph }}</p>
      }
    </div>
  }

  @for (group of content().groups; track group.title) {
    <div class="starter-guide__group">
      <h3 class="starter-guide__group-title">{{ group.title }}</h3>
      <app-starter-guide-group-carousel
        [items]="group.items"
        (zoomOpen)="onZoomOpen($event)"
        (addToCart)="onAddToCart($event)"
        (notifyRequest)="onNotifyRequest($event)"
        (notifyCancel)="onNotifyCancel($event)"
        (cardClick)="onCardClick($event)"
        (reserveClick)="onReserveClick($event)"
      />
    </div>
  }

  <!-- Sin categoría no hay catálogo al que enviar: el CTA no se pinta. -->
  @if (categorySlug(); as slug) {
    <div class="starter-guide__footer">
      <a [routerLink]="['/tienda', slug]">
        <app-button variant="secondary">{{ ctaLabel() }}</app-button>
      </a>
    </div>
  }
</div>
